module.exports = __webpack_public_path__ + "img/undraw_blooming_jtv6.5fac76fa.svg";